import { compose, lifecycle, withHandlers, withState } from "recompose";
import RaisedTextCollapsible from "./RaisedTextCollapsible";

function componentWillMount() {
  const { setIsCollapsed } = this.props;
  setIsCollapsed(false);
}

const onToggleCollapse = props => () => {
  props.setIsCollapsed(!props.isCollapsed);
};

export default compose(
  withState("isCollapsed", "setIsCollapsed", false),
  withHandlers({ onToggleCollapse }),
  lifecycle({ componentWillMount })
)(RaisedTextCollapsible);



// WEBPACK FOOTER //
// ./src/app/components/UI/RaisedText/RaisedTextCollapsibleContainer.js